import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';

export default function languageChanged(
    locale$: BehaviorSubject<string>,
    platformCapabilities: Set<string>,
    teardowns: (() => void)[]
) {
    if (!platformCapabilities.has('languageChanged')) {
        return;
    }

    return function(callback: (locale?: string) => void) {
        /* 
         Since locale$ needs to be a BehaviorSubject for other subscribers, 
         languageChanged should skip the initial value since it's emitted upon 
         subscribing and isn't really changing at that time.
        */
        const sub = locale$.pipe(skip(1)).subscribe(callback);
        const unsub = () => sub.unsubscribe();
        teardowns.push(unsub);

        return unsub;
    };
}
